import { OBJECT_TYPE_SEAT } from '%paysera_seat_selection/js/seatSelection/config/constants';

const resolveUserPurchasedReservations = (seatings, userId) => seatings.reduce(
    (accumulator, currentValue) => {
        if (currentValue.type !== OBJECT_TYPE_SEAT) {
            return accumulator;
        }

        if (currentValue.user === userId) {
            accumulator.userSeats.push(currentValue);
        } else if (currentValue.user !== null) {
            accumulator.reservedSeats.push(currentValue);
        }

        return accumulator;
    },
    { userSeats: [], reservedSeats: [] },
);

export default resolveUserPurchasedReservations;
